import { useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { LoadingState } from "@/components/PageUi";

/** The backend callback has already captured consent and queued execution; the bill page shows live status. */
export function BillPaymentReturnPage() {
  const { billId } = useParams<{ billId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const status = searchParams.get("status");
    if (status === "authorised") {
      toast.success("Payment authorised - your bank is processing it now");
    } else if (status === "failed") {
      toast.error("The bank payment was not authorised");
    }
    navigate(billId ? `/bills/${billId}` : "/bills", { replace: true });
  }, [billId, navigate, searchParams]);

  return (
    <div className="mx-auto w-full max-w-md p-6">
      <LoadingState label="Back from your bank. Opening the bill..." />
    </div>
  );
}
